import { render, staticRenderFns } from "./WidgetEditorDialog.vue?vue&type=template&id=0cc6c5e7&"
import script from "./WidgetEditorDialog.vue?vue&type=script&lang=js&"
export * from "./WidgetEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports